module.exports = __webpack_public_path__ + "img/zibal.90394ce5.svg";